import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../utils/axios';
import { APP_BANNER_LIST } from 'src/constants/queryKeys';

export const networkGetNotificationBannerInfo = async (bannerId) => {
  const res = await axiosInstance.post(`NotificationBanner/Info/{${bannerId}`);
  return res;
};

export const networkGetNotificationBannerList = async (appId, sectionKeyOrder, pageIndex = 0, pageSize = 50) => {
  const PAYLOAD = {
    sectionKeyOrder: sectionKeyOrder,
  };

  const res = await axiosInstance.post(`NotificationBanner/ListPanel/${pageIndex}/${pageSize}/${appId}`, PAYLOAD);
  return res;
};

export function useFetchBannerList(appId, sectionKeyOrder, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: [APP_BANNER_LIST, appId, sectionKeyOrder, pageIndex],
    queryFn: () => networkGetNotificationBannerList(appId, sectionKeyOrder, pageIndex, pageSize),
  });
}

export const networkCreateNotificationBanner = async (data) => {
  const res = await axiosInstance.post('NotificationBanner/Insert', data);
  return res;
};

export const networkUpdateNotificationBanner = async (bannerId, data) => {
  const res = await axiosInstance.post(`NotificationBanner/Update/${bannerId}`, data);
  return res;
};

export const networkRemoveNotificationBanner = async (bannerId) => {
  const res = await axiosInstance.post(`NotificationBanner/Remove/${bannerId}`);
  return res;
};

export const networkNotificationBannerMove = async (projectId, payload) => {
  const res = await axiosInstance.post(`NotificationBanner/Move/${projectId}`, payload);
  return res;
};

export const networkGetNotificationBannerTypeList = async () => {
  const res = await axiosInstance.post(`NotificationBannerType/List`);
  return res;
};

export function useFetchNotificationBannerTypeList() {
  return useQuery({
    queryKey: ['notification-banner-type-list'],
    queryFn: networkGetNotificationBannerTypeList,
  });
}

export const networkGetNotificationBannerValueType = async () => {
  const res = await axiosInstance.post(`NotificationBannerValueType/List`);
  return res;
};

export function useFetchNotificationBannerValueType() {
  return useQuery({
    queryKey: ['notification-banner-value-type-list'],
    queryFn: networkGetNotificationBannerValueType,
  });
}
